import api from '../../utils/api';

export const onboardHospitalVendor = async (data: any) => {
  return api.post('/master-admin/vendor-onboarding/hospital', data);
};

export const onboardAmbulanceVendor = async (data: any) => {
  return api.post('/master-admin/vendor-onboarding/ambulance', data);
};

export const onboardClinicVendor = async (data: any) => {
  return api.post('/master-admin/vendor-onboarding/clinic', data);
};

export const onboardMedicalStoreVendor = async (data: any) => {
  return api.post('/master-admin/vendor-onboarding/medical-store', data);
};

export const onboardBloodBankVendor = async (data: any) => {
  return api.post('/master-admin/vendor-onboarding/blood-bank', data);
};

export const onboardDiagnosticCenterVendor = async (data: any) => {
  return api.post('/master-admin/vendor-onboarding/diagnostic-center', data);
};

export const onboardProductPartnerVendor = async (data: any) => {
  return api.post('/master-admin/vendor-onboarding/product-partner', data);
};

// Update vendor functions
export const updateHospitalVendor = async (vendorId: string, data: any) => {
  return api.put(`/master-admin/vendor-updation/hospital/${vendorId}`, data);
};

export const updateAmbulanceVendor = async (vendorId: string, data: any) => {
  return api.put(`/master-admin/vendor-updation/ambulance/${vendorId}`, data);
};

export const updateClinicVendor = async (vendorId: string, data: any) => {
  return api.put(`/master-admin/vendor-updation/clinic/${vendorId}`, data);
};

export const updateMedicalStoreVendor = async (vendorId: string, data: any) => {
  return api.put(`/master-admin/vendor-updation/medical-store/${vendorId}`, data);
};

export const updateBloodBankVendor = async (vendorId: string, data: any) => {
  return api.put(`/master-admin/vendor-updation/blood-bank/${vendorId}`, data);
};

export const updateDiagnosticCenterVendor = async (vendorId: string, data: any) => {
  return api.put(`/master-admin/vendor-updation/diagnostic-center/${vendorId}`, data);
};

export const updateProductPartnerVendor = async (vendorId: string, data: any) => {
  return api.put(`/master-admin/vendor-updation/product-partner/${vendorId}`, data);
};

export const fetchVendorsBySalesExecutive = async (salesExecutiveId: string) => {
  return api.get(`/master-admin/by-salesexecutive/${salesExecutiveId}`);
};

export const deleteVendorById = async (vendorId: string) => {
  return api.delete(`/master-admin/vendors/${vendorId}`);
}; 